export class StageService {
  constructor($resource, ApiService) {
    "ngInject";

    this.$resource = $resource;
    this.apiService = ApiService;

    // endpoint
    const endpoint = this.apiService.getResourceUrl("/tasks");
    const taskApproveEndpoint = this.apiService.getResourceUrl(
      "/tasks/task-approve"
    );
    // CMVR Center CRUD
    this.resource = this.$resource(endpoint, null, {
      create: { method: "post" },
      update: { method: "put" },
    });
    this.taskApproveResource = this.$resource(taskApproveEndpoint, null, {
      create: { method: "post" },
    });
  }
  getVeteranStageTasks(stageId, memberId) {
    return this.resource.get({ stageId, memberId }).$promise;
  }
  approveMemberTasks(stageId, memberId, taskIds) {
    return this.taskApproveResource.create({ stageId, memberId }, { taskIds }).$promise;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/stages/stages.service.js